"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompensationCSVRequestModel () {
        return CompensationCSVRequestModel;
    },
    get CompensationCycleIdParams () {
        return CompensationCycleIdParams;
    },
    get CreateCompensationCycleRequest () {
        return CreateCompensationCycleRequest;
    },
    get GetUsersWithoutCompensationDataParams () {
        return GetUsersWithoutCompensationDataParams;
    },
    get ListCompensationCycleQueryParams () {
        return ListCompensationCycleQueryParams;
    },
    get UpdateCompensationCycleRequest () {
        return UpdateCompensationCycleRequest;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../../base");
const _helpers = require("../../search-service/base/helpers");
const _enums = require("./enums");
const CreateCompensationCycleRequest = _zod.z.object({
    name: _zod.z.string().min(1).max(255),
    startDate: _utilsisomorphic.transformDate,
    dueDate: _utilsisomorphic.transformDate,
    approvalType: _zod.z.enum([
        "chain",
        "manager"
    ]),
    allotmentIncrease: _zod.z.number().min(0),
    userSelectionId: _utilsisomorphic.transformObjectId,
    totalEligibleCompensation: _zod.z.number().min(0),
    managerOverrides: _zod.z.record(_zod.z.string(), _zod.z.object({
        value: _utilsisomorphic.transformObjectId,
        label: _zod.z.string().min(1)
    }).nullable())
});
const UpdateCompensationCycleRequest = _zod.z.object({
    name: _zod.z.string().min(1).max(255).optional(),
    dueDate: _utilsisomorphic.transformDate.optional(),
    startDate: _utilsisomorphic.transformDate.optional()
});
const ListCompensationCycleQueryParams = _base.BaseQueryParams.extend({
    status: _enums.CompensationCycleStatusContract.optional(),
    search: _zod.z.string().optional()
});
const CompensationCycleIdParams = _zod.z.object({
    cycleId: _utilsisomorphic.transformObjectId
});
const GetUsersWithoutCompensationDataParams = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId
});
const CompensationCSVRequestModel = _zod.z.object({
    search: _helpers.SearchField.optional(),
    sorts: _zod.z.record(_zod.z.string(), _zod.z.number()).optional()
});
